<template lang="pug">
    .contentpage
        .section(v-if="filteredSections.length" v-for="(section, index) in filteredSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            //- Slider(v-if="section.key === 'slider'" :section="section")
            //- PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            //- CategoryPosts(v-if="section.key === 'categoryposts'" :max="4" :category="section.category")
            //- Banners(v-if="section.key === 'banners'" :banners="section.contents")
            //- SocialWall(v-if="section.key === 'socialwall'")
            LoginForm(v-if="section.key === 'login'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
// import Slider from '@/components/Slider'
// import PhotoAlbum from '@/components/PhotoAlbum'
// import CategoryPosts from '@/components/CategoryPosts'
// import SocialWall from '@/components/SocialWall'
// import Banners from '@/components/Banners'
import LoginForm from '@/components/LoginForm'

export default {
    name: 'LoginPage',
    components: {
        Heading,
        ImageSection,
        Post,
        // Slider,
        // PhotoAlbum,
        // CategoryPosts,
        // SocialWall,
        // Banners,
        LoginForm,
    },
    computed: {
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'post'
                    || section.key === 'image'
                    || section.key === 'login'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    }
}

</script>

<style lang="sass" scoped></style>
